import React from "react";

import cx from "classnames";

import styles from "./RewardSection.module.scss";

import IconArrowRight from "assets/icons/iconArrowRight.svg";

const RewardSection = ({
  className,
  currentPoints,
  onRewardClick,
  rewards,
  title
}) => (
  <div className={cx(className)}>
    <h4 className="body-20 fw-bold color-charcoal">{title}</h4>
    <div className={cx(styles.rewardRow, "d-flex flex-wrap mt-2")}>
      {rewards.map((reward, idx) => (
        <button
          disabled={currentPoints < reward.points}
          className={cx(styles.rewardContainer, "p-3")}
          key={reward.id}
          onClick={() => onRewardClick(reward)}
          type="button"
        >
          <div className="d-flex flex-row align-items-center justify-content-between">
            <img
              alt={reward.title}
              className={cx(styles.rewardImage)}
              width={60}
              height={68}
              src={reward.image_url}
            />
            <img
              alt={reward.title}
              src={IconArrowRight}
              width={20}
              height={20}
            />
          </div>
          <p className="body-15 fw-bold text-start">{reward.title}</p>
          <p
            className={cx(
              "caption-13 text-start mt-1",
              currentPoints < reward.points ? "color-negative" : "color-green"
            )}
          >
            {reward.points} point{reward.points !== 1 ? "s" : ""}
          </p>
        </button>
      ))}
    </div>
  </div>
);

export default RewardSection;
